module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_9016.b7d92fc2.png";